export default __webpack_public_path__ + "static/media/supported_by.4716c508.png";